import { GraphicElementApi } from '@/types/GraphicElement';
import Layer, { GroupLayer } from '@/types/Layer';
import { GraphicElementMapper } from './GraphicElementMapper';

export class LayerMapper {
    static getLayerFromElement(graphicElement: GraphicElementApi): Layer | GroupLayer {
        const { uuid, type, visible } = graphicElement;
        const layer: Layer | GroupLayer = {
            id: uuid,
            typeId: this.getType(type) || 'text',
            content: GraphicElementMapper.getContentByType(graphicElement),
            visible: visible,
            isLocked: graphicElement.isLocked || false
        };

        if (graphicElement.colorGroups) {
            //@ts-ignore
            layer.colors = graphicElement.colorGroups.map((colorGroup) => ({
                hexaValue: colorGroup.color.hexaValue,
                id: colorGroup.id
            }));
        }

        return layer;
    }

    static getType(type: string) {
        if (type === 'CustomGraphicElement') {
            return 'group';
        } else {
            return type?.toLowerCase();
        }
    }
}
